<div class="burger-menu" (click)="toggleMenu()">
  <span></span>
  <span></span>
  <span></span>
</div>
